import {  Descriptions, Timeline, Tag, Table } from 'antd'
import moment from 'moment'
import React from 'react'
import { SearchBarWithTimeRange } from './SearchBar'
import { Button } from 'react-bootstrap'
import Icon, { RestOutlined } from '@ant-design/icons'

const fieldLabels = {
  status: 'Status',
  mineNumber: 'Mine Number',
  serialNumber: 'Serial Number',
  manufacturingDate: 'Manufacturing Date',
  warrantyExpiration: 'Warranty Expiration',
  model: 'Model',
  comment: 'Comment',
  mine: 'Mine'
};

const getStatusColor = (status) => {
  const colors = {
    active: 'green',
    inactive: 'red',
    quarantined: 'orange',
    collected: 'blue',
    repaired: 'cyan',
    rrepair: 'purple',
    unrepairable: 'magenta',
    enroute: 'geekblue',
    ber: 'volcano',
    expired: 'red'
  };
  return colors[status?.toLowerCase()] || 'default';
};

export  function AutiTrailSCSR({loadscsrAuditTrail,scsrAuditTrai}) {
  return (
    <>
     
            <>
              <SearchBarWithTimeRange search={(e) => loadscsrAuditTrail(e,null)} />
              <>
                <Timeline mode="left">
                  {scsrAuditTrai?.map((autitrail, index) => (
                    <Timeline.Item
                      key={index}
                      color={autitrail?.newData?.status==="active" ? "green":"red"}
                      label={moment(autitrail?.createdAt).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}
                    >
                      <div style={{ marginBottom: '16px', padding: '12px', background: '#fafafa', borderRadius: '8px' }}>
                        <Descriptions
                          column={1}
                          layout="horizontal"
                          size="small"
                          title={<span style={{ fontSize: '14px' }}>Action: <Tag color="blue">{autitrail?.action?.toUpperCase()}</Tag></span>}
                        >
                          <Descriptions.Item label="Modified By">
                            {autitrail?.modifiedBy
                              ? `${autitrail?.modifiedBy?.name} ${autitrail?.modifiedBy?.surname}`
                              : "-"}
                          </Descriptions.Item>
                        </Descriptions>
                        
                        {autitrail?.changes?.length > 0 && (
                          <div style={{ marginTop: '12px' }}>
                            <strong style={{ fontSize: '13px', marginBottom: '8px', display: 'block' }}>Changes:</strong>
                            <Table
                              size="small"
                              pagination={false}
                              dataSource={autitrail?.changes?.map((change, i) => ({
                                key: i,
                                field: fieldLabels[change.field] || change.field,
                                oldValue: change.oldValue,
                                newValue: change.newValue,
                                fieldKey: change.field
                              }))}
                              columns={[
                                {
                                  title: 'Field',
                                  dataIndex: 'field',
                                  key: 'field',
                                  width: '30%',
                                  render: (text) => <strong>{text}</strong>
                                },
                                {
                                  title: 'Previous Value',
                                  dataIndex: 'oldValue',
                                  key: 'oldValue',
                                  width: '35%',
                                  render: (text, record) => (
                                    record.fieldKey === 'status' 
                                      ? <Tag color={getStatusColor(text)}>{text?.toUpperCase() || '-'}</Tag>
                                      : <span style={{ color: '#999' }}>{text || '-'}</span>
                                  )
                                },
                                {
                                  title: 'New Value',
                                  dataIndex: 'newValue',
                                  key: 'newValue',
                                  width: '35%',
                                  render: (text, record) => (
                                    record.fieldKey === 'status' 
                                      ? <Tag color={getStatusColor(text)}>{text?.toUpperCase() || '-'}</Tag>
                                      : <span style={{ fontWeight: 'bold' }}>{text || '-'}</span>
                                  )
                                }
                              ]}
                            />
                          </div>
                        )}
                        
                        {(!autitrail?.changes || autitrail?.changes?.length === 0) && (
                          <div style={{ marginTop: '8px' }}>
                            <Descriptions.Item label="Status">
                              <Tag color={getStatusColor(autitrail?.newData?.status)}>
                                {autitrail?.newData?.status?.toUpperCase()}
                              </Tag>
                            </Descriptions.Item>
                            {autitrail?.newData?.comment && (
                              <p style={{ marginTop: '8px' }}><strong>Comment:</strong> {autitrail?.newData?.comment}</p>
                            )}
                          </div>
                        )}
                      </div>
                    </Timeline.Item>
                  ))}
                </Timeline>
              </>

            
              
            </>
         
    </>
  )
}

export  function AutiTrailInscpetions({loadscsrAuditTrail,scsrAuditTrai,restoreInspection}) {
    return (
      <>
       
              <>
                <SearchBarWithTimeRange search={(e) => loadscsrAuditTrail(e,null)} />
                <>
              
               
                  <Timeline mode="left">
                    {scsrAuditTrai?.map((autitrail) => (
                      <Timeline.Item
                        color={autitrail?.changes?.status==="active" ? "green":"red"}
                        label={moment(autitrail?.createdAt).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                      >
                        <p>
               {JSON.stringify(autitrail?.inspections )}  
               
               {/* {JSON.stringify(autitrail?.inspections )}  */}

                        </p>
                        <p> 
<Button style={{margin:"0"}} size='sm' variant='warning'  onClick={()=>restoreInspection(autitrail._id)} ><RestOutlined/>  </Button>
                            
                          <Descriptions
                            column={1}
                            layout="horizontal"
                            title="Details"
                          >
                               {/* <Descriptions.Item label="Previously Inspected By">
                            {autitrail?.modifiedBy
                              ? `${autitrail?.previousData?.inspectedBy?.email} `
                              : "-"}
                            </Descriptions.Item> */}
                           
                            <Descriptions.Item label="Modify By">
                            {autitrail?.modifiedBy
                              ? `${autitrail?.modifiedBy?.name} ${autitrail?.modifiedBy?.surname}`
                              : "-"}
                            </Descriptions.Item>
                           
                            <Descriptions.Item label="Status" >
                            
                             <div style={{fontWeight:"bold",color:autitrail?.newData?.status==="active" ? "green":"red"}}> {autitrail?.newData?.status?.toUpperCase()}</div>
                            </Descriptions.Item>
                            <Descriptions.Item label="Comments">
                              <p> {autitrail?.newData?.comment}</p>
                            </Descriptions.Item>
                          </Descriptions>
                        </p>
                      </Timeline.Item>
                    ))}
                  </Timeline>
                </>
  
              
                
              </>
           
      </>
    )
  }

  